import { instance } from '@/services/avik-api-gateway'
import { DeviationCancelProposal } from '@/types/deviation-cancel-proposal'
import { AxiosResponse } from 'axios'

interface FetchParams {
  from: string
  to: string
}

let abortController: AbortController

export function getDeviationCancelProposals(
  params: FetchParams
): Promise<AxiosResponse<DeviationCancelProposal[]>> {
  if (abortController) {
    abortController.abort()
    abortController = new AbortController()
  } else {
    abortController = new AbortController()
  }
  return instance.get(`/deviation-cancel-proposal`, {
    params,
    signal: abortController.signal,
  })
}
